// Параметры сетки «мяса» тела — зеркало server/internal/game/bodyvox.go.

import { BODY_VOX_GRID_BYTES } from "../net/protocol";

export const BODY_VOX_SX = 10;
export const BODY_VOX_SY = 10;
export const BODY_VOX_SZ = 24;
export const BODY_VOX_CUBE = 0.07;
export const BODY_VOX_OX = -0.35;
export const BODY_VOX_OY = -0.35;
export const BODY_VOX_OZ = 0.05;

/** Всего ячеек в сетке тела (должно совпадать с proto). */
export const BODY_VOX_CELL_COUNT = BODY_VOX_SX * BODY_VOX_SY * BODY_VOX_SZ;

export { BODY_VOX_GRID_BYTES };

/** Число живых (бит=1) ячеек в битмаске bodyVox. */
export function countAliveBodyVoxCells(vox: Uint8Array): number {
  if (vox.length !== BODY_VOX_GRID_BYTES) return 0;
  let n = 0;
  for (let i = 0; i < BODY_VOX_GRID_BYTES; i++) {
    const B = vox[i]!;
    if (B === 0xff) {
      n += 8;
      continue;
    }
    if (B === 0) continue;
    for (let b = 0; b < 8; b++) {
      if ((B >> b) & 1) n++;
    }
  }
  return n;
}

/**
 * Если живых вокселей совсем мало, каркас даёт только «леску»/окантовку — не рисуем inner mesh.
 * Порог подобран выше шумового хвоста от тонкой оболочки после тяжёлого урона.
 */
export const BODY_VOX_MIN_ALIVE_TO_RENDER_INNER = 20;

export function bodyVoxTooSparseToRenderInner(vox: Uint8Array | null): boolean {
  if (!vox || vox.length !== BODY_VOX_GRID_BYTES) return false;
  return countAliveBodyVoxCells(vox) < BODY_VOX_MIN_ALIVE_TO_RENDER_INNER;
}
